import script from "./QuillEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./QuillEditor.vue?vue&type=script&setup=true&lang=js"

import "./QuillEditor.vue?vue&type=style&index=0&id=62ea74fb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62ea74fb"]])

export default __exports__